import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1cc664c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "notice-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "notice-title" }
const _hoisted_5 = {
  key: 0,
  class: "dot"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "notice-bottom" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "通知公告", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, {
      right: _withCtx(() => [
        _createVNode(_component_svg_icon, {
          "icon-class": "envelope",
          onClick: _ctx.setallreaded
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: _ctx.loading,
            "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loading) = $event)),
            finished: _ctx.finished,
            "finished-text": "没有更多了",
            onLoad: _ctx.onLoad
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noticeList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "notice-block",
                  key: index,
                  onClick: ($event: any) => (_ctx.fGoNoticeDetail(item))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    (item.readFlag == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "notice-content",
                    innerHTML: item.content
                  }, null, 8, _hoisted_6),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, _toDisplayString(item.createDate), 1),
                    _hoisted_8
                  ])
                ], 8, _hoisted_3))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ])
  ]))
}